import { ref, readonly } from 'vue'

const height = ref(0)

export function useToolbarHeight() {
  return {
    height: readonly(height),
    setHeight: (v: number) => (height.value = v),
  }
}